import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../general.service';
import { DataService } from '../data.service';
import {TranslateService} from '@ngx-translate/core';

declare var Hashes: any;

@Component({
  selector: 'app-logindemo',
  templateUrl: './logindemo.component.html',
  styleUrls: [
    './logindemo.component.scss'
  ]
})

export class LoginDemoComponent implements OnInit {

  constructor(
    public generalSvc: GeneralService,
    public dataSvc: DataService,
    public translate: TranslateService
  ) {
  }
  

  ngOnInit() {
    this.dataSvc.initLogin("demo", "demo");
  }
}